import { getLocaleLanguage } from './../../locales/index'
import { LGPlatformEnum } from './constant'

import vantEnLocale from 'vant/lib/locale/lang/en-US'
import vantZhLocale from 'vant/lib/locale/lang/zh-CN'
import vantZhHkLocale from 'vant/lib/locale/lang/zh-HK'

const env = process.env.VUE_APP_ENV || 'development'

console.log('envMain', getLocaleLanguage())
/**
 * @description: 语言SDK配置文件
 */
const config = {
  env: env,
  platform: LGPlatformEnum.META_LANDING_PAGE,
  locale: getLocaleLanguage().toLowerCase(),
  customLocale: {
    'zh-Hans': 'zh'
  },
  customLabels: {
    zh: {
      ...vantZhLocale
    },
    'zh-Hant': {
      ...vantZhHkLocale
    },
    others: {
      ...vantEnLocale
    }
  }
}

export default config
